// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"80efaec7","513":"d2131ee0","703":"3cbe6478","787":"3928f488"}[chunkId] + ".chunk.js";
};